import fetchApi from "../fetchApi";
export const DeleteSellOrder = async ({ id, office_id }) => {

    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            office_id: office_id,
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/sell-order/${id}/void`, options);
};